export const SET_USER = 'USER/SET_USER'
export const SET_TOKEN = 'USER/SET_TOKEN'
export const INITIALIZATION = 'INITIALIZATION'
